import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBHbglRc2OctJvkoatplHcNHNShCgGAUSE",
  authDomain: "loanme-40153.firebaseapp.com",
  projectId: "loanme-40153",
  storageBucket: "loanme-40153.firebasestorage.app",
  messagingSenderId: "559380171955",
  appId: "1:559380171955:web:0486e90018caa0ad7974c6",
  measurementId: "G-LBVGX04PCV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
